export default __webpack_public_path__ + "static/media/inactive-sleep.de101e25.svg";